namespace My {
    export class FastLinkVerificationIndex extends BaseForm<FastLinkVerificationModel, any> {
        protected passwordRecoveryService: PasswordRecoveryService;

        protected $userName = $("#UserName");
        protected regexEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        protected regexPhoneNumber = /^\d{9,11}$/
        protected $userNameInput = $("#UserName")
        protected $btnSubmit = $(".btn-submit-reset")
        protected linkOPT = "/confirm-opt";

        constructor(container: JQuery, opt?: any) {
            super(container, opt);
        }

        protected onInit(): void {
            this.passwordRecoveryService = new PasswordRecoveryService();
        }

        protected bindingEvents(): void {
            this.$userNameInput.on("keydown", (e) => {
                if (e.key === "Enter") {
                    this.submitFormReset()
                }
            })

            this.$btnSubmit.on("click", () => {
                this.submitFormReset();
            })
        }

        public countdownSubmitReset(seconds) {
            $(".btn-submit-reset").prop("disabled", true)
            $(".time-wrap").removeClass("d-none");

            var countdownInterval = setInterval( () => {
                $("#coundown-reset").text(seconds);
                seconds--;
                if (seconds < 0) {
                    $("#coundown-reset").text(seconds);
                    clearInterval(countdownInterval);
                    $(".btn-submit-reset").prop("disabled", false);
                    $(".time-wrap").addClass("d-none");
                }
            }, 1000);
        }

        public async submitFormReset() {
            var userName = this.$userName.val();
            var textError = $(".text-error");
            var isEmail = this.regexEmail.test(userName.toString())

            textError.addClass("d-none")
            if (!this.validateFormResetPassword()) {
                textError.removeClass("d-none");
                return;
            }

            if (this.checkCookie('send-request-reset-password')) {
                var timeCookie = this.getTimeRemaining()
                this.countdownSubmitReset(timeCookie)
                return;
            }

            var res = await this.passwordRecoveryService.generateResetPasswordToken(userName, isEmail);
            if (res.IsOk) {
                if (res.Code == "0") {
                    this.setValueCookie()
                    if (isEmail) {
                        UIUtils.showToastSuccess(Utils.l("ForgotPassword.Email.ToastSuccess"));
                    } else {

                        window.location.href += (this.linkOPT + "?phoneNumber=" + userName)
                    }
                } else {
                    UIUtils.showToastError(Utils.l("ForgotPassword.ToastError"));
                }
            } else {
                UIUtils.showToastError(Utils.l("ForgotPassword.ToastError"));
            }
        }

        public setValueCookie() {
            var timeCookie = new Date();
            timeCookie.setTime(timeCookie.getTime() + (2 * 60 * 1000));
            var timeCookieValue = timeCookie.getTime();
            this.setCookie('send-request-reset-password', timeCookieValue, 2);
        }

        public getTimeRemaining() {
            var timeCookie = this.getCookie('send-request-reset-password')
            var timeNow = new Date();
            var timeNowValue = timeNow.getTime();
            var second = (Number(timeCookie) - timeNowValue) / 1000;
            return Math.floor(second);
        }

        public setCookie(cookieName, cookieValue, expirationMinutes) {
            var expirationDate = new Date();
            expirationDate.setTime(expirationDate.getTime() + (expirationMinutes * 60 * 1000));
            var expires = "expires=" + expirationDate.toUTCString();
            document.cookie = cookieName + "=" + cookieValue + "; " + expires + "; path=/";
        }

        public getCookie(cookieName) {
            var name = cookieName + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');

            for (var i = 0; i < cookieArray.length; i++) {
                var cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                    return cookie.substring(name.length, cookie.length);
                }
            }

            return "";
        }

        public checkCookie(cookieName) {
            let user = this.getCookie(cookieName);

            if (user != "") {
                return true
            }
            return false
        }

        public validateFormResetPassword() {
            var userName = this.$userName.val().toString();
            if (userName != "" && (this.regexEmail.test(userName) || this.regexPhoneNumber.test(userName))) {
                return true;
            }
            return false;
        }
    }
}